export const $googleCountries = function() {
  var googleCountries = ['US', 'GB', 'UK', 'AU', 'CA', 'FR', 'DE', 'ES', 'AR', 'BR', 'BG', 'CN', 'DK', 'FI', 'GR', 'HU', 'IN', 'IE', 'IL', 'IT', 'JP', 'MX', 'NL', 'NZ', 'NO', 'PL', 'PT', 'RO', 'RU', 'ZA', 'KR', 'SE', 'TR'];
  return googleCountries;
};